export { default } from './ProductScreenshots'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ProductScreenshots/index.js